import { render, staticRenderFns } from "./IpqcTemplateEdit.vue?vue&type=template&id=1ced88e3&"
import script from "./IpqcTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./IpqcTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports